// eslint-disable-next-line import/prefer-default-export
export const BIKE_TYPE = () => ({
  n: 1, // 单车
  e: 2, // 助力车
});
